import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { Children, cloneElement, useMemo, isValidElement } from 'react';
import { createPortal } from 'react-dom';
import mergeRefs from 'react-merge-refs';
import { useStyles, useToken, StyleSheet, text, padding, margin, border } from '@rexlabs/styling';
import { Tether } from '@rexlabs/tether';
import { TransitionSingle } from '@rexlabs/animation';
var defaultArrowSize = 12;
var defaultStyles = StyleSheet({
  tooltip: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, padding.styles({
    target: 'tooltip',
    all: 's'
  })), margin.styles({
    target: 'tooltip',
    all: 'none'
  })), border.styles({
    target: 'tooltip',
    all: {
      radius: 'm'
    }
  })), {}, {
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('tooltip.background.color', token('color.container.static.dark'));
    },
    minWidth: function minWidth(_ref2) {
      var token = _ref2.token;
      return token('tooltip.minWidth', 'auto');
    },
    maxWidth: function maxWidth(_ref3) {
      var token = _ref3.token;
      return token('tooltip.maxWidth', '20rem');
    },
    '&, & p': _objectSpread({}, text.styles({
      target: 'tooltip',
      fallback: 'small.default',
      color: function color(_ref4) {
        var token = _ref4.token;
        return token('color.textStyle.body.contrast');
      }
    })),
    '& p': _objectSpread(_objectSpread({}, padding.styles({
      target: 'tooltip.paragraph',
      top: 'none',
      bottom: 'xs'
    })), {}, {
      '&:last-child': {
        paddingBottom: 0
      }
    })
  }),
  arrow: {
    '&::before': {
      background: function background(_ref5) {
        var token = _ref5.token;
        return token('tooltip.background.color', token('color.container.static.dark'));
      }
    }
  },
  content: {
    position: 'relative',
    zIndex: 2
  }
});

function getPlacementAnimation(placement) {
  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'top')) {
    return {
      from: {
        marginBottom: -5
      },
      enter: {
        marginBottom: 0
      },
      leave: {
        marginBottom: -5
      }
    };
  }

  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'right')) {
    return {
      from: {
        marginLeft: -5
      },
      enter: {
        marginLeft: 0
      },
      leave: {
        marginLeft: -5
      }
    };
  }

  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'bottom')) {
    return {
      from: {
        marginTop: -5
      },
      enter: {
        marginTop: 0
      },
      leave: {
        marginTop: -5
      }
    };
  }

  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'left')) {
    return {
      from: {
        marginRight: -5
      },
      enter: {
        marginRight: 0
      },
      leave: {
        marginRight: -5
      }
    };
  }

  return {};
} // We need unique ids for the aria attributes, so we simply use
// incremental ids for all tooltip instances


var counter = 0; // HACK: this way we avoid having to render a TooltipContext to be able to close
// the currently open tooltip immediately when hovering quickly over another
// tooltip

var currentOpen;
export function Tooltip(_ref6) {
  var children = _ref6.children,
      _ref6$isDisabled = _ref6.isDisabled,
      isDisabled = _ref6$isDisabled === void 0 ? false : _ref6$isDisabled,
      _ref6$placement = _ref6.placement,
      placementProp = _ref6$placement === void 0 ? 'top' : _ref6$placement,
      distanceProp = _ref6.distance,
      _ref6$portalTarget = _ref6.portalTarget,
      portalTarget = _ref6$portalTarget === void 0 ? window.document.body : _ref6$portalTarget,
      Content = _ref6.Content;
  var s = useStyles(defaultStyles, 'Tooltip');
  var token = useToken();
  var uuid = useMemo(function () {
    return ++counter;
  }, []);
  var arrowSize = token('tooltip.arrow.size', token('arrow.size', defaultArrowSize));
  var distance = token('tooltip.distance', distanceProp);
  var child = Children.only(children);
  return /*#__PURE__*/React.createElement(Tether, {
    disabled: isDisabled,
    placement: placementProp,
    arrowSize: arrowSize,
    distance: distance
  }, function (_ref7) {
    var isOpen = _ref7.isOpen,
        placement = _ref7.placement,
        referenceProps = _ref7.referenceProps,
        popperProps = _ref7.popperProps,
        arrowProps = _ref7.arrowProps,
        setOpen = _ref7.setOpen;

    function handleOpen() {
      var _currentOpen;

      if (((_currentOpen = currentOpen) === null || _currentOpen === void 0 ? void 0 : _currentOpen.uuid) !== uuid) {
        var _currentOpen2, _currentOpen2$close;

        (_currentOpen2 = currentOpen) === null || _currentOpen2 === void 0 ? void 0 : (_currentOpen2$close = _currentOpen2.close) === null || _currentOpen2$close === void 0 ? void 0 : _currentOpen2$close.call(_currentOpen2);
        setOpen(true);
        currentOpen = {
          uuid: uuid,
          close: function close() {
            return setOpen(false);
          }
        };
      }
    }

    function handleClose() {
      setOpen(false);
      currentOpen = null;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/isValidElement(child) ? /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, referenceProps), {}, {
      ref: mergeRefs([referenceProps.ref, child.ref]),
      'aria-describedby': "tooltip-".concat(uuid),
      onMouseEnter: handleOpen,
      onMouseLeave: handleClose,
      onFocus: handleOpen,
      onBlur: handleClose
    })) : null, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(TransitionSingle, {
      show: isOpen,
      configs: ['fade', {
        delay: token('tooltip.delay', 0)
      }, getPlacementAnimation(placement), {
        config: {
          mass: 1,
          tension: 320,
          friction: 26
        }
      }]
    }, /*#__PURE__*/React.createElement("div", _extends({}, popperProps, {
      key: "tooltip",
      id: "tooltip-".concat(uuid),
      role: "tooltip",
      onMouseEnter: handleOpen,
      onMouseLeave: handleClose
    }), /*#__PURE__*/React.createElement("div", _extends({}, arrowProps, s.with('arrow')({
      style: arrowProps.style,
      className: arrowProps.className
    }))), /*#__PURE__*/React.createElement("div", s('tooltip'), /*#__PURE__*/React.createElement("div", s('content'), Content && /*#__PURE__*/React.createElement(Content, {
      isOpen: isOpen,
      setOpen: setOpen
    }))))), portalTarget));
  });
}
export default Tooltip;